module.exports = __webpack_public_path__ + "assets/Schwindel.edd682ba.png";